/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import AppContainer from "../../Components/Structure/AppContainer";
import ajaxStudent from "../../util/remote/ajaxStudent";
import useStateCallback from "../../util/customHooks/useStateCallback";
import TableHeader from "../../Components/Common/TableHeader";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import StudentContext from "../../Context/StudentContext";
import SummaryCount from "../../Components/Students/SummaryCount";
import AssignCard from "../../Components/Students/AssignCard";
import StudentBioData from "../../Components/Students/StudentBioData";
import StudentContacts from "../../Components/Students/StudentContacts";
import StudentCallLogs from "../../Components/Students/AdminProfile/StudentCallLogs";
import Pagination from "../../Components/Common/Pagination";
import StudentTransactions from "../../Components/Students/AdminProfile/StudentTransactions";
import AddStudentContact from "../../Components/Students/AddStudentContact";
import EditPicture from "../../Components/Students/EditPicture";
import PocketMoneyTransactions from "../../Components/Students/AdminProfile/PocketMoneyTransactions";
import Loader from "../../Components/Common/Loader";
import ActivateAccount from "../../Components/Students/ActivateAccount";
import UpdateNames from "../../Components/SystemUsers/UpdateNames";
import ajaxCallStation from "../../util/remote/ajaxCallStation";
import ajaxBank from "../../util/remote/ajaxBank";
import ajaxCard from "../../util/remote/ajaxCard";
import RenewCard from "../../Components/Students/RenewCard";
import RestrictAccount from "../../Components/Students/RestrictAccount";
import UnrestrictAccount from "../../Components/Students/UnrestrictAccount";
import RestrictCalls from "../../Components/Students/RestrictCalls";
import EnableCalls from "../../Components/Students/EnableCalls";
import { RenderSecure } from "../../util/script/RenderSecure";
import StudentAccessLogs from "../../Components/Students/AdminProfile/StudentAccessLogs";
import EditClass from "../../Components/Students/EditClass";
import StudentRankings from "../../Components/Students/StudentRankings";
import AuthContext from "../../Context/AuthContext";
import ConvertCreditToPM from "../../Components/Students/AdminProfile/ConvertCreditToPM";
import SharePocketMoney from "../../Components/Students/AdminProfile/SharePocketMoney";
import DeleteFingerprint from "../../Components/Students/DeleteFingerprint";

const StudentProfilePage = (props) => {
  const {studentProfile, setStudentId, setStudentUserId, getStudentProfile, loading3} = useContext(StudentContext);
  const [modal, setModal] = useStateCallback(false);
  const { student_id, user_id } = useParams();
  const [contactLoader, setContactLoader] = useState(false);
  const [studentLogs, setStudentLogs] = useState([]);
  const [logsPage, setLogsPage] = useState(1);
  const [logsMeta, setLogsMeta] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [pkMoneyPage, setPkMoneyPage] = useState(1);
  const [pkMoneyMeta, setPkMoneyMeta] = useState([]);
  const [pkMoneyLoading, setPkMoneyLoading] = useState(false);
    const [cardAttachmentValue, setCardAtttachmentValue] = useState(false);
  const [pkMoneyTransactions, setPkMoneyTransactions] = useState([]);
  const [studentAccessLogs, setStudentAccessLogs] = useState([]);
  const [accessLogsPage, setAccessLogsPage] = useState(1);
  const [accessLogsMeta, setAccessLogsMeta] = useState([]);
  const [accessLogsLoading, setAccessLogsLoading] = useState(false);
  const [studentLogCount, setStudentLogCount] = useState(false);
  const [studentContactCount, setStudentContactCount] = useState(false);
  const [studentWalletBalance, setStudentWalletBalance] = useState(false);
  const [studentPocketMoney, setStudentPocketMoney] = useState(false);
  const [studentContacts, setStudentContacts] = useState([]);
  const [studentTransactions, setStudentTransactions] = useState([]);
  const [transactionLoading, setTransactionLoading] = useState(false);
  const [transactionPage, setTransactionPage] = useState(1);
  const [transactionMeta, setTransactionMeta] = useState([]);
  const [pocketMoneyLimit, setPocketMoneyLimit] = useState([]);
  const [studentCardHistory, setStudentCardHistory] = useState([]);
  const [studentRank, setStudentRank] = useState(null);
  const [rankLoading, setRankLoading] = useState(false);
  const [fingerprintStatus, setFingerprintStatus] = useState(false);
  const [fingerprintEnrollmentDate, setFingerprintEnrollmentDate] = useState(false);
  const [faceStatus, setFaceStatus] = useState(false);
  const [termlyFeeStatus, setTermlyFeeStatus] = useState(false);


  const [authumRegNo, setAuthumRegNo] = useState(false);

  const { userId } = useContext(AuthContext);



  useEffect(() => {
    setStudentId(student_id);
  }, [student_id, setStudentId]);

  useEffect(() => {
    setStudentUserId(user_id);
  }, [user_id, setStudentUserId]);

  useEffect(() => {
      if (user_id) {
        getStudentTransactions(transactionPage, user_id);
      }
    }, [transactionPage, user_id]);

  useEffect(() => {
      if (user_id) {
        getStudentLogs(logsPage, user_id);
      }
    }, [logsPage, user_id]);

    useEffect(() => {
      if (user_id) {
        getStudentAccessLogs(accessLogsPage, user_id);
      }
    }, [accessLogsPage, user_id]);

    useEffect(() => {
      if (student_id) {
        getFirstCardAttachmentValue(student_id);
        getStudentCardHistory(student_id);
        getStudentFingerprintStatus(student_id);
        getStudentAuthumRegNo(student_id);
        getStudentFingerprintEnrollmentDate(student_id);
        getStudentFaceStatus(student_id);
      }
    }, [student_id]);

  useEffect(() => {
    if (user_id) {
      countLogs();
      countStudentContacts();
      getStudentWalletBalance();
      getStudentPocketMoneyBalance();
      getStudentContacts();
      getPocketMoneyLimit();
      getStudentRank();
      getTermlyFeeStatus();

      }
  }, [user_id]);

  useEffect(() => {
      if (user_id) {
        getStudentPocketMoneyTransactions(pkMoneyPage, user_id);
      }
    }, [pkMoneyPage, user_id]);

  const countLogs = async () => {
      setStudentLogCount(false)
      if (!user_id) return;
      const server_response = await ajaxCallStation.countStudentLogs(user_id);
      if (server_response.status === "OK") {
        setStudentLogCount(server_response.details);
      } else {
        setStudentLogCount("404");
      }
  };

  const getStudentTransactions = async (currentPage) => {
    if (!user_id) return;
    setTransactionLoading(true);
    const server_response = await ajaxBank.fetchUserWalletTransactions(currentPage, user_id);
    setTransactionLoading(false);
    if (server_response.status === "OK") {
      setTransactionMeta(server_response.details.meta.totalPages);
      setStudentTransactions(server_response.details.list);
    } else {
      setStudentTransactions([]);
    }
  };

  const getStudentPocketMoneyBalance = async () => {
      setStudentPocketMoney(false)
      if (!user_id) return;
      const server_response = await ajaxBank.fetchPocketMoneyBalance(user_id);
      if (server_response.status === "OK") {
        setStudentPocketMoney(server_response.details);
      } else {
        setStudentPocketMoney('0');
      }
    };

    const getStudentContacts = async () => {
      if (!user_id) return;
      setContactLoader(true);
      const server_response = await ajaxStudent.fetchStudentContacts(user_id);
      setContactLoader(false);
      if (server_response.status === "OK") {
        setStudentContacts(server_response.details);
      } else {
        //communicate error
        setStudentContacts([]);
      }
    };

    const getStudentCardHistory = async () => {
      if (!student_id) return;
      const server_response = await ajaxCard.fetchStudentCardHistory(student_id);
      
      if (server_response.status === "OK") {
        setStudentCardHistory(server_response.details.list);
      } else {
        //communicate error
        setStudentCardHistory([]);
      }
    };

  const countStudentContacts = async () => {
      setStudentContactCount(false);
      if (!user_id) return;
      const server_response = await ajaxStudent.countStudentContacts(user_id); 
      if (server_response.status === "OK") {
        setStudentContactCount(server_response.details);
      } else {
        //communicate error
        setStudentContactCount("404");
      }
  };

  const getStudentWalletBalance = async () => {
      setStudentWalletBalance(false)
      if (!user_id) return;
      const server_response = await ajaxBank.fetchStudentWalletBalance(user_id);
      if (server_response.status === "OK") {
        setStudentWalletBalance(server_response.details);
      } else {
        setStudentWalletBalance('0');
      }
  };

  const getPocketMoneyLimit = async () => {
    const server_response = await ajaxStudent.getPocketMoneyLimit(user_id);
    if (server_response.status === "OK") {
      setPocketMoneyLimit(server_response.details);
    } else {
      setPocketMoneyLimit(false);
    }
  };

  const getStudentRank = async () => {
      setStudentRank(null)
      if (!user_id) return;
      setRankLoading(true);
      const server_response = await ajaxStudent.getStudentRank(user_id);
      setRankLoading(false);
      if (server_response.status === "OK") {
        setStudentRank(server_response.details);
      } else {
        setStudentRank(null);
      }
  };

  const getTermlyFeeStatus = async () => {
    const server_response = await ajaxStudent.getTermlyFeeStatus(user_id);
    if (server_response.status === "OK") {
      setTermlyFeeStatus(server_response.details);
    } else {
      setTermlyFeeStatus(false);
    }
  };



  const getStudentFingerprintStatus= async () => {
      if (!student_id) return;
      const server_response = await ajaxStudent.getStudentFingerprintStatus(student_id);
      if (server_response.status === "OK") {
        setFingerprintStatus(server_response.details);
      } else {
        //communicate error
        setFingerprintStatus(false);
      }
    };

    const getStudentFaceStatus= async () => {
      if (!student_id) return;
      const server_response = await ajaxStudent.getStudentFaceStatus(student_id);
      if (server_response.status === "OK") {
        setFaceStatus(server_response.details);
      } else {
        //communicate error
        setFaceStatus(false);
      }
    };

    const getStudentFingerprintEnrollmentDate= async () => {
      if (!student_id) return;
      const server_response = await ajaxStudent.getStudentFingerprintEnrollmentDate(student_id);
      if (server_response.status === "OK") {
        setFingerprintEnrollmentDate(server_response.details);
      } else {
        //communicate error
        setFingerprintEnrollmentDate(false);
      }
    };

    const getStudentAuthumRegNo = async () => {
      if (!student_id) return;
      const server_response = await ajaxStudent.getStudentAuthumRegNo(student_id);
      if (server_response.status === "OK") {
        setAuthumRegNo(server_response.details);
      } else {
        //communicate error
        setAuthumRegNo(false);
      }
    };

  
  const handleModal3 = () => {
    setModal(false, () =>
      setModal(
        <AddStudentContact
          userID={user_id}
          h={getStudentContacts}
          j={countStudentContacts}
          isOpen={true}
        />
      )
    );
  };

  const handleUpdateGroup = (e, studentProfile) => {
    setModal(false, () => setModal(<EditClass studentID={student_id} g={getStudentProfile} schoolID={studentProfile.school_id} groupID={studentProfile.group_id} isOpen={true}/>));
  };

  const handleUpdateName = (e, studentProfile) => {
    setModal(false, () => setModal(<UpdateNames userID={user_id} g={getStudentProfile} firstName={studentProfile.first_name} lastName={studentProfile.last_name} isOpen={true}/>));
  };

  const payActivationFee = () => {
    setModal(false, () =>
      setModal(
        <ActivateAccount
          userID={user_id}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const getStudentLogs = async (currentPage) => {
      if (!user_id) return;
      setLogsLoading(true);
      const server_response = await ajaxCallStation.listStudentCallLogs(
        currentPage,
        user_id
      );
      setLogsLoading(false);
      if (server_response.status === "OK") {
        setLogsMeta(server_response.details.meta.totalPages);
        setStudentLogs(server_response.details.data|| []);
      } else {
        setStudentLogs([]);
      }
  };

  const getStudentAccessLogs = async (currentPage) => {
    if (!user_id) return;
    setAccessLogsLoading(true);
    const server_response = await ajaxStudent.accessStudentLogs(
      currentPage,
      user_id
    );
    setAccessLogsLoading(false);
    if (server_response.status === "OK") {
      setAccessLogsMeta(server_response.details.meta.totalPages);
      setStudentAccessLogs(server_response.details.data|| []);
    } else {
      setStudentAccessLogs([]);
    }
};

  const getStudentPocketMoneyTransactions = async (currentPage) => {
      if (!user_id) return;
      setPkMoneyLoading(true);
      const server_response = await ajaxBank.fetchUserPocketMoneyTransactions(currentPage, user_id);
      setPkMoneyLoading(false);
      if (server_response.status === "OK") {
        setPkMoneyMeta(server_response.details.meta.totalPages);
        setPkMoneyTransactions(server_response.details.data || []);
      } else {
        setPkMoneyTransactions([]);
      }
    };

    const getFirstCardAttachmentValue = async () => {
      const server_response = await ajaxCard.checkFirstCardAttachment(student_id);
      if (server_response.status === "OK") {
        setCardAtttachmentValue(server_response.details);
      } else {
        setCardAtttachmentValue(false);
      }
    };

    

  const assignCard = () => {
    setModal(false, () =>
      setModal(
        <AssignCard
          studentID={student_id}
          fullName={studentProfile.full_name}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const renewCard = () => {
    setModal(false, () =>
      setModal(
        <RenewCard
          studentID={student_id}
          fullName={studentProfile.full_name}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const editPicture = () => {
    setModal(false, () =>
      setModal(
        <EditPicture
          userID={user_id}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };


  const restrictAccount = () => {
    setModal(false, () =>
      setModal(
        <RestrictAccount
          accountID={user_id}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const unrestrictAccount = () => {
    setModal(false, () =>
      setModal(
        <UnrestrictAccount
          accountID={user_id}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const restrictCalls = () => {
    setModal(false, () =>
      setModal(
        <RestrictCalls
          accountID={user_id}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const unrestrictCalls = () => {
    setModal(false, () =>
      setModal(
        <EnableCalls
          accountID={user_id}
          g={getStudentProfile}
          isOpen={true}
        />
      )
    );
  };

  const deleteFingerprint = () => {
    setModal(false, () =>
      setModal(
        <DeleteFingerprint
          studentID={student_id}
          g={getStudentProfile}
          h={getStudentFingerprintStatus}
          isOpen={true}
        />
      )
    );
  };

  const convertCredit = () => {
    setModal(false, () =>
      setModal(
        <ConvertCreditToPM
          userID={user_id}
          h={getStudentWalletBalance}
          i={getStudentPocketMoneyBalance}
          j={getStudentPocketMoneyTransactions}
          k={getStudentTransactions}
          cpage={transactionPage}
          pkPage={pkMoneyPage}
          isOpen={true}
        />
      )
    );
  };

  const sharePM = () => {
    setModal(false, () =>
      setModal(
        <SharePocketMoney
          senderID={user_id}
          g={getStudentPocketMoneyBalance}
          h={getStudentPocketMoneyTransactions}
          page={pkMoneyPage}
        />
      )
    );
  };

  

  const handleLogsPagination = (newPage) => {
    if (newPage > 0 && newPage <= logsMeta) {
      setLogsPage(newPage);
    }
  };

  const handleTransactionPagination = (newPage) => {
    if (newPage > 0 && newPage <= transactionMeta) {
      setTransactionPage(newPage);
    }
  };

  const handlePocketMoneyPagination = (newPage) => {
    if (newPage > 0 && newPage <= pkMoneyMeta) {
      setPkMoneyPage(newPage);
    }
  };

  const handleAccessLogsPagination = (newPage) => {
    if (newPage > 0 && newPage <= accessLogsMeta) {
      setAccessLogsPage(newPage);
    }
  };

  const syncAuthum = async(e, studentProfile)=>{
      const server_response = await ajaxStudent.syncAuthumAccount(user_id, studentProfile.username);
      if(server_response.status==="OK"){
          toast.success(server_response.message);
          getStudentProfile();
      }else{
          //communicate error
          toast.error(server_response.message); 
      }
  }

  const syncAuthumDetails = async(e, studentProfile)=>{
      const server_response = await ajaxStudent.syncAuthumDetails(user_id, studentProfile.authum_id);
      if(server_response.status==="OK"){
          toast.success(server_response.message);
          getStudentProfile();
      }else{
          //communicate error
          toast.error(server_response.message); 
      }
  }

  return (
    <AppContainer title={"Student Profile"}>
      <Toaster position="top-center" reverseOrder={false} />
      {modal}
      <section class="section profile">
        <div class="row">
          <div class="col-xl-4">
            <div className="row">
              <div class="col-lg-12">

                
                <div class="cards gradient-my-blue" style={{borderRadius:"10px"}}>
                  <div class="cards">
                    <div class="card-body profile-card pt-4 d-flex flex-column gradient-my-blue" style={{padding:"20px"}}>
                      <div class="main-img-user mb-2" style={{justifyContent:"center", display:"flex"}}>
                        <img
                          alt="avatar"
                          style={{ height: "150px", borderRadius:"50%", padding:"5px", border:"5px solid #ff7200"}}
                          src={studentProfile.profile_pic!==""?studentProfile.profile_pic:
                            process.env.PUBLIC_URL +
                            "/assets/img/figure/user55.png"
                          }
                        />
                      </div>
                      <h3 style={{ color: "white", textAlign:"center", margin:"10px 0"}}>
                        {studentProfile? studentProfile.full_name: "... ..."}
                      </h3>
                      <h5 style={{ color: "white", textAlign:"center", margin:"0" }}>{studentProfile? studentProfile.group:".. .."}</h5>
                      
                    </div>
                  </div>
                </div>
               
                <ul class="list-group list-group-flush bg" style={{display: "flex", flexDirection: "column", paddingLeft: "0", borderTop: "#dee2e6 solid 5px"}}>
                    
                    <li class="p-0 list-group-item">
                        <div class="grid-menu grid-menu-2col">
                            <div class="no-gutters row" style={{marginRight: "0", marginLeft: "0", display:"grid"}}>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={payActivationFee} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-toggle-on btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"#28a745"}}> </i>Activate Account
                                    </button>
                                </div>
                                <div class="col-sm-12" style={{borderBottom: "#dee2e6 solid 5px", borderRight: "#dee2e6 solid 5px"}}>
                                    {cardAttachmentValue?<button onClick={renewCard} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-id-card btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"#17a2b8"}}> </i>Replace Card / Wristband
                                    </button>:<button onClick={assignCard} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-id-card btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"#17a2b8"}}> </i>Assign Card / Wristband
                                    </button>}
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={editPicture} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-image-portrait btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"#117a8b"}}> </i>Canteen Picture
                                    </button>
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={(e) => handleUpdateName(e, studentProfile)} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-edit btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", "color":"#ffc107"}}> </i>Change Names
                                    </button>
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={(e) => handleUpdateGroup(e, studentProfile)} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-users btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", "color":"#ffc107"}}> </i>Edit Group / Class
                                    </button>
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                {studentProfile.is_call_restricted ==="0"?<button onClick={restrictCalls} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-phone-slash btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"#DE3163"}}> </i>Disable Calls
                                    </button>:<button onClick={unrestrictCalls} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-phone btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"green"}}> </i>Enable Calls
                                    </button>}
                                </div>
                                <RenderSecure code="ADMIN-VIEW"><div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                {studentProfile.is_active ==="1"?<button onClick={restrictAccount} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-ban btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"red"}}> </i>Block Account
                                    </button>:<button onClick={unrestrictAccount} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-ban btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"gray"}}> </i>Unblock Account
                                    </button>}
                                </div></RenderSecure>
                                 <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                {fingerprintStatus?<button onClick={deleteFingerprint} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fas fa-fingerprint btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"red"}}> </i>Delete Fingerprint
                                    </button>:""}
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                {studentProfile.authum_id ==="N/A"?<button onClick={(e) => syncAuthum(e, studentProfile)} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-rotate btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", color:"gray"}}> </i>Sync with Authum
                                    </button>:""}
                                </div>
                               
                                
                            </div>
                        </div>
                    </li>
                </ul>
                {studentCardHistory.length > 0 && (
                  <div className="cards pt-3">
                    <div className="card-body profile-card pt-4 d-flex flex-column">
                      <TableHeader title="Card / Wristband History" />
                      <div className="user-manager scroll-widget border-top">
                        <div className="table-responsive">
                          <table className="table mg-b-0">
                            <tbody>
                              {studentCardHistory.map((item, index) => (
                                <tr key={index}>
                                  <td class="bd-t-0">
												            <div class="main-img-user">
                                      {item.type ==="CARD"?<img alt="avatar" style={{ height: "50px" }} src={process.env.PUBLIC_URL + "/assets/img/figure/id-card.png"}/>:<img alt='avatar' style={{ height: '50px' }} src={process.env.PUBLIC_URL + '/assets/img/figure/smart.png'}/>}
                                    </div>
											            </td>
                                  <td className="bd-t-0">
                                    <h6 className="mg-b-0">{item.card_number}</h6>
                                    <small className="tx-11 tx-gray-500">{item.type}</small>
                                  </td>
                                  <td className="bd-t-0">
                                    <small>Lost on {item.created_at.short_date}</small><br/>
                                    <small className="tx-11 tx-gray-500">Marked lost by {item.marked_by}</small>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
)}
              </div>
              
              
              {/* <SchoolsAttended studentProfile={studentProfile} studentTransfers={studentTransfers}/> */}
             
               
            </div>
          </div>
          <div className="col-xl-8">
            <div className="row">
            <SummaryCount contactCount={studentContactCount} logsCount={studentLogCount} walletBalance={studentWalletBalance} pocketMoney={studentPocketMoney}/>

              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body pt-3">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="first"
                    >
                      <Row>
                        <Col sm={12}>
                          <Nav variant="pills" className="flex-row mb-1">
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="first">
                                Bio{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="second">
                                Contacts{" "}
                              </Nav.Link>
                            </Nav.Item>
                             <Nav.Item>
                              <Nav.Link size="sm" eventKey="third">
                                Calls{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="fourth">
                                Credit Transactions{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="fifth">
                                Pocket Money Transactions{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <RenderSecure code="ADMIN-VIEW"><Nav.Item>
                              <Nav.Link size="sm" eventKey="sixth">
                                Access Logs{" "}
                              </Nav.Link>
                            </Nav.Item></RenderSecure>
                          </Nav>
                        </Col>

                        <Col sm={12}>
                          <Tab.Content>
                            <Tab.Pane eventKey="first">
                              {loading3 ? (
                                <Loader /> 
                              ) : (
                                <StudentBioData studentProfile={studentProfile} pocketMoneyLimit={pocketMoneyLimit} fingerprintStatus={fingerprintStatus} faceStatus={faceStatus} enrollmentDate={fingerprintEnrollmentDate} authumNo={authumRegNo} termlyFeeStatus={termlyFeeStatus}/>                           
                              )}
                              <RenderSecure code="ADMIN-VIEW">

                              {rankLoading ? (
                                <Loader /> 
                              ) : (
                                <StudentRankings studentRank={studentRank}/>                           
                              )}
                              </RenderSecure>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                              <TableHeader
                                subtitle="List of all the student's contacts"
                                viewButton={
                                  <Link onClick={handleModal3}className="btn btn-info"style={{ float: "right" }}>
                                    Add Contact
                                  </Link>
                                }
                              />

                              <StudentContacts loading={contactLoader} studentContacts={studentContacts} countStudentContacts={countStudentContacts} getStudentContacts={getStudentContacts}/>

                            </Tab.Pane>

                            <Tab.Pane eventKey="third">
                              <StudentCallLogs studentLogs={studentLogs} loading2={logsLoading}/>
                              <Pagination currentPage={logsPage} totalPages={logsMeta} onPageChange={handleLogsPagination}/>
                              
                            </Tab.Pane>


                            <Tab.Pane eventKey="fourth">
                              {["1973", "4749", "9"].includes(userId) ? (<TableHeader
                                viewButton={
                                  <Link onClick={convertCredit} className="btn btn-info mb-1" style={{ float: "right" }}>
                                    Convert Credit to Pocket Money
                                  </Link>
                                }
                              />):null}
                              <StudentTransactions loading4={transactionLoading} walletTransactions={studentTransactions}/>
                              <Pagination currentPage={transactionPage} totalPages={transactionMeta} onPageChange={handleTransactionPagination}/>
                              
                            </Tab.Pane>

                            <Tab.Pane eventKey="fifth">
                              {["1973", "4749", "9"].includes(userId) ? (<TableHeader
                                viewButton={
                                  <Link onClick={sharePM} className="btn btn-info mb-1" style={{ float: "right" }}>
                                    Share Pocket Money
                                  </Link>
                                }
                              />):null}
                              <PocketMoneyTransactions loading5={pkMoneyLoading} pocketMoneyTransactions={pkMoneyTransactions}/>
                              <Pagination currentPage={pkMoneyPage} totalPages={pkMoneyMeta} onPageChange={handlePocketMoneyPagination}/>
                              
                            </Tab.Pane>
                            <RenderSecure code="ADMIN-VIEW"><Tab.Pane eventKey="sixth">
                              <StudentAccessLogs loading2={accessLogsLoading} studentAccessLogs={studentAccessLogs}/>
                              <Pagination currentPage={accessLogsPage} totalPages={accessLogsMeta} onPageChange={handleAccessLogsPagination}/>
                              
                            </Tab.Pane></RenderSecure>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </AppContainer>
  );
};

export default StudentProfilePage;
